import React from 'react';
import PropTypes from 'prop-types';
import BaseCell from '../base-cell/index';
import classNames from 'classnames';
import isMobile from '../../../../utils/isMobile';
import { VideoContents } from './contents.jsx';
import AvatarIcon from '../../../common/avatarIcon';

export default class VideoCell extends BaseCell {

  render() {
    const {isBot, baseParams, url, time, iconSrc, withoutDate} = this.props;
    const { textCellStyle, avatarStyle } = this.getCellStyle({isBot, baseParams, iconSrc});
    const classFull = classNames({
      'cu-ui-message-full-video': isMobile(),
      'cu-ui-message-video': !isMobile()
    });

    return (
      <div className={this.messageClass(isBot) + ' ' + classFull}>
        <div className={'cu-ui-message-block cu-ui-text-count-data'} { ...this.textCountCustomAttributes }>
          <div className={'cu-ui-message-avatar'} style={avatarStyle}>
            { !(isBot || iconSrc && iconSrc.length !== 0) && <AvatarIcon />}
          </div>
          <div className={'cu-ui-message-content'} style={textCellStyle} tabIndex="0">
            <VideoContents url={url} />
          </div>
        </div>
        {
          !withoutDate && <div className={'cu-ui-message-time'}>{time}</div>
        }
      </div>
    );
  }
}

VideoCell.propTypes = {
  url: PropTypes.string,
  time: PropTypes.string,
  isBot: PropTypes.bool,
  iconSrc: PropTypes.string
};
